import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ShopContext = createContext({ connected: false, loading: true, shop: null });

export const useShop = () => useContext(ShopContext);

export function ShopProvider({ children }) {
  const [status, setStatus] = useState({ connected: false, loading: true, shop: null });

  useEffect(() => {
    api
      .get("/shop/status")
      .then((r) => setStatus({ ...r.data, loading: false }))
      .catch(() => setStatus({ connected: false, loading: false, shop: null }));
  }, []);

  return <ShopContext.Provider value={status}>{children}</ShopContext.Provider>;
}
